import type { FC } from "react";

import {
    StyledButtonChipItem,
    StyledFilterDivider,
} from "app/pages/sales-intelligence/pages/premium-features/components/PremiumFeatureFilter/styles";
import premiumFeatureTrackingService from "app/pages/sales-intelligence/services/tracking/premium-feature/trackingService";

interface PremiumFeatureFilterProps {
    allFilters: readonly string[];
    selectedFilters: readonly string[];
    setFilters: (filters: string[]) => void;
}
export const PremiumFeatureFilter: FC<PremiumFeatureFilterProps> = ({ allFilters, selectedFilters, setFilters }) => {
    const handleOnClick = (item: string) => {
        let filters = [];
        if (selectedFilters.includes(item)) {
            premiumFeatureTrackingService.trackPremiumFeatureClickFilter(`Deselect/${item}`);
            filters = selectedFilters.filter((filter: string) => filter !== item);
        } else {
            premiumFeatureTrackingService.trackPremiumFeatureClickFilter(`Select/${item}`);
            filters = [...selectedFilters, item];
        }

        setFilters(filters);
    };

    const handleSelectAll = () => {
        premiumFeatureTrackingService.trackPremiumFeatureClickFilter(`Select/All`);
        setFilters([]);
    };

    return (
        <>
            <StyledButtonChipItem
                hideActionButton
                text="All"
                isSelected={selectedFilters.length === 0}
                onClick={handleSelectAll}
            />
            <StyledFilterDivider />
            {allFilters.map((item: string) => {
                return (
                    <StyledButtonChipItem
                        key={item}
                        text={item}
                        isSelected={selectedFilters.includes(item)}
                        hideActionButton={false}
                        onClick={() => handleOnClick(item)}
                    />
                );
            })}
        </>
    );
};
